import { filter, map, Subject } from 'rxjs';
import {
  getCookie,
  getData,
  metricsLog,
  setData
} from './utils';
import { PixelsVideoEvent } from '../../constants/Video';
import { MetricsStorage } from './types';

export const addedByPixels = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {
  const adTimeChange$ = sub.pipe(
    filter(([type]) => PixelsVideoEvent.VIDEO_BEFORE_PLAY === type),
    map(([, { videoId }]) => videoId === (window as { [key: string]: any }).top[window.top.__pixelsLayerKey]?.swappedVideoId),
  );

  adTimeChange$.subscribe((value) => {
    const uuid = getCookie(pixelsUUIDKey);
    const storageKey = `${uuid}-${typeOfIntegration}`;
    const data:  MetricsStorage = getData(storageKey);
    metricsLog(`Swapped by pixels detected.`);

    setData(storageKey, {
      ...data,
      added_by_pixels: {
        value
      },
    });
  });
};